import React from 'react';
import dayjs from 'dayjs';
import { isNil } from 'ramda';

import { formatByLocale } from 'utils/date';

interface IDateCell {
  value?: string | Date;
}

const DateCell: React.FC<IDateCell> = ({ value }) => {
  if (isNil(value) || !dayjs(value).isValid()) {
    return null;
  }
  return <>{formatByLocale(dayjs(value).toDate())}</>;
};

DateCell.displayName = 'DateCell';

export default DateCell;
